var Murmur = require('./src/index.js');

module.exports = Murmur;